import { redirect, createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ForgotPassword } from '@/pages/auth/reset-password/ForgotPassword';
import { SIGNUP_DETAILS_ROUTE, isSignupIncomplete } from '@/lib/incomplete-signup';

// The address is the only thing this route carries. `code` used to ride here too, which put a live
// reset secret in browser history and the address bar; nothing produces such a link (the reset
// email carries a code, not a URL), so it is gone (audit EP-10).
//
// `email` means a code is already out for that address, so the route opens straight on the code
// step. `prefillEmail` only fills the field a screen elsewhere already knows the answer to - the
// signup step's "account already exists" escape - and still asks the person to press Continue.
const searchSchema = z.object({
	email: z.coerce.string().trim().toLowerCase().optional(),
	prefillEmail: z.coerce.string().trim().toLowerCase().optional(),
});

export const Route = createFileRoute('/forgot-password')({
	validateSearch: searchSchema,
	beforeLoad: ({ context }) => {
		const { authenticated, user } = context.globalStore.getState();
		if (!authenticated) return;
		if (isSignupIncomplete(user)) throw redirect(SIGNUP_DETAILS_ROUTE);
		throw redirect({ to: '/' });
	},
	component: ForgotPassword,
});
